import api from "../../../core/api";
import { ChangeServiceReport, MachinePartGroup, ServiceReport, ServiceReportsPage, ServiceReportsQuery } from "../models/ServiceReportsModel";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
};

class CustomerMachineServiceReportApi {
  getServiceReports(query: ServiceReportsQuery, machineId: string): Promise<ServiceReportsPage> {
    return api
      .get<ServiceReportsPage>(`/v1/customer/machines/${machineId}/service-reports`, {
        ...getRequestConfig(),
        params: query,
        paramsSerializer: { indexes: null }
      })
      .then((x) => x.data);
  }

  getServiceReport(serviceReportNumber: string): Promise<ServiceReport> {
    return api.get<ServiceReport>(`/v1/customer/service-reports/${serviceReportNumber}`, getRequestConfig()).then((x) => x.data);
  }

  createServiceReport(model: ChangeServiceReport, machineId: string): Promise<string> {
    return api.post<string>(`/v1/customer/machines/${machineId}/service-reports`, model, getRequestConfig()).then((x) => x.data);
  }

  changeServiceReport(serviceReportNumber: string, model: ChangeServiceReport) {
    return api.put<any>(`/v1/customer/service-reports/${serviceReportNumber}`, model, getRequestConfig());
  }

  createSolvingServiceReport(serviceReportNumber: string, model: ChangeServiceReport) {
    return api
      .post<string>(`/v1/customer/service-reports/${serviceReportNumber}/solving-report`, model, getRequestConfig())
      .then((x) => x.data);
  }

  changeSolvingServiceReport(serviceReportNumber: string, model: ChangeServiceReport) {
    return api.put<any>(`/v1/customer/service-reports/${serviceReportNumber}/solving-report`, model, getRequestConfig());
  }

  deleteServiceReport(serviceReportNumber: string): Promise<any> {
    return api.delete(`/v1/customer/service-reports/${serviceReportNumber}`, getRequestConfig());
  }

  getMachineParts(): Promise<MachinePartGroup[]> {
    return api.get<MachinePartGroup[]>(`/v1/machine-parts`, getRequestConfig()).then((x) => x.data);
  }
}

export default new CustomerMachineServiceReportApi();